import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { Play } from 'lucide-react'
import { useUser } from '@renderer/context/UserContext'
import { CurrentActivity } from '@renderer/components/ui/CurrentActivity'
import { LearningProgress } from '@renderer/components/ui/LearningProgress'
import { AvailableCourses } from '@renderer/components/ui/AvailableCourses'
import { useBreadcrumbs } from '@renderer/context/BreadcrumbContext'

export const Dashboard = () => {
  const navigate = useNavigate()
  const { user } = useUser()
  const { setBreadcrumbs } = useBreadcrumbs()

  useEffect(() => {
    setBreadcrumbs([{ label: 'Home' }])
  }, [])

  const getFirstName = (): string => {
    if (!user?.email) return 'User'
    const name = user.email.split('@')[0]
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  const getGreeting = (): string => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Good morning'
    if (hour < 18) return 'Good afternoon'
    return 'Good evening'
  }

  return (
    <div className="relative -mx-4 md:-mx-8 lg:-mx-[41px] -mt-[41px] overflow-hidden">
      <div
        className="pointer-events-none absolute inset-x-0 top-0"
        style={{
          height: 'clamp(180px, 22vw, 280px)',
          backgroundImage:
            'linear-gradient(to right, rgba(168,144,96,0.13) 1px, transparent 1px), linear-gradient(to bottom, rgba(168,144,96,0.13) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
          WebkitMaskImage: 'radial-gradient(ellipse 80% 100% at 50% 0%, #000 50%, transparent 100%)',
          maskImage: 'radial-gradient(ellipse 80% 100% at 50% 0%, #000 50%, transparent 100%)'
        }}
      />
      <div className="relative pt-[41px] px-4 md:px-8 lg:px-[41px] max-w-[1200px] mx-auto space-y-5">
      <section>
        <div className="relative flex flex-col items-start gap-3 pt-4 pb-1 sm:items-center sm:text-center sm:pt-7 sm:pb-3">
          <span
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium"
            style={{ color: '#7a6020', background: '#f5ede0', border: '1px solid #e0d4be' }}
          >
            Hands-on AI labs
          </span>
          <h1
            style={{
              fontFamily: "'Source Serif 4', serif",
              fontWeight: 600,
              fontSize: 'clamp(1.875rem, 6.5vw, 68px)',
              lineHeight: 1.08,
              letterSpacing: '-0.022em'
            }}
            className="text-[#181820] max-w-2xl"
          >
            {getGreeting()}, <span style={{ color: '#7a6020', fontStyle: 'italic' }}>{getFirstName()}</span>
          </h1>
          <p className="max-w-xl text-sm text-[#5A5A6D]">
            You&apos;re making great progress! Continue your certification journey and hit your weekly goal.
          </p>
          <div className="flex flex-wrap items-center gap-2.5 mt-1">
            <button
              onClick={() => navigate('/main')}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-xs font-bold text-white transition-opacity hover:opacity-90"
              style={{ background: '#7a6020' }}
            >
              <Play className="w-3 h-3 fill-white" />
              Continue Learning
            </button>
            <button
              onClick={() => navigate('/main')}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-xs font-bold text-[#181820]"
              style={{ background: '#f5ede0', border: '1px solid #e0d4be' }}
            >
              View Path
            </button>
          </div>
        </div>
      </section>

      <div className="flex flex-col lg:flex-row gap-4">
        <div
          className="w-full lg:w-3/5 rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.07)]"
          style={{ minHeight: 'clamp(240px, 24vw, 320px)' }}
        >
          <CurrentActivity />
        </div>
        <div className="w-full lg:w-2/5" style={{ minHeight: 'clamp(240px, 24vw, 320px)' }}>
          <LearningProgress />
        </div>
      </div>

      <AvailableCourses limit={3} onBrowse={() => navigate('/main')} />
      </div>
    </div>
  )
}
